import { render } from "./ProductSelectSection.vue?vue&type=template&id=23444e6d&scoped=true"
import script from "./ProductSelectSection.vue?vue&type=script&lang=js"
export * from "./ProductSelectSection.vue?vue&type=script&lang=js"

import "./ProductSelectSection.vue?vue&type=style&index=0&id=23444e6d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.38_vue@3.2.13_webpack@5.94.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23444e6d"]])

export default __exports__